import React, { useState, useEffect, useRef } from "react"
import styled, { css } from "styled-components"
import { em } from "polished"

const Expandable = ({ translations, children, className, Toggle }) => {
  const [expandable, setExpandable] = useState(true)
  const [expanded, setExpanded] = useState(false)
  const contentRef = useRef()
  const toggleClickedRef = useRef(false)

  const toggleClick = () => {
    toggleClickedRef.current = true
    setExpanded((v) => !v)
  }

  useEffect(() => {
    if (!expanded && toggleClickedRef.current && contentRef.current)
      contentRef.current.scrollIntoView({
        behavior: `smooth`,
        block: `nearest`,
      })

    toggleClickedRef.current = false
  }, [expanded])

  useEffect(() => {
    if (
      contentRef.current &&
      contentRef.current.offsetHeight + 5 >= contentRef.current.scrollHeight
    )
      setExpandable(false)
  }, [])

  if (!children) return null

  return (
    <Container className={className}>
      <Content ref={contentRef} $expandable={expandable} $expanded={expanded}>
        {children}
      </Content>

      {expandable && (
        <ToggleWrap>
          <Toggle as="button" type="button" onClick={toggleClick}>
            {expanded
              ? translations.global.showLess
              : translations.global.showMore}
          </Toggle>
        </ToggleWrap>
      )}
    </Container>
  )
}

export default Expandable

const Container = styled.div``

const Content = styled.div`
  ${({ $expandable, $expanded }) =>
    $expandable &&
    css`
      max-height: ${em(420)};
      overflow: hidden;
      mask: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 1) 50%,
        rgba(0, 0, 0, 0) 100%
      );

      ${$expanded &&
      css`
        max-height: none;
        overflow: visible;
        mask: none;
        margin-bottom: ${em(30)};
      `}
    `}
`

const ToggleWrap = styled.div`
  button {
    text-align: center;
  }
`
